const BreadcrumbService = {
    siteGroup: null
}

export default BreadcrumbService;
